import {
    add as addToAlwaysInCacheList,
    remove as removeFromAlwaysInCacheList,
} from './alwaysInCacheTableIdList';
import { getFolderChangeDigestAction } from 'owa-mail-focused-inbox-rollup-store';
import { isFocusedInboxEnabled } from 'owa-mail-triage-common';
import {
    getNonFocusedInboxTableQuery,
    getFocusedInboxTableQuery,
    getOtherInboxTableQuery,
} from 'owa-mail-triage-table-utils/lib/getDefaultInboxTableQueries';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util';

export const FOCUSED_INBOX = 'FOCUSED';
export const OTHER_INBOX = 'OTHER';
export const ALL_INBOX = 'ALL';

/**
 * Reset the always in cache inbox table views
 */
export default function updateAlwaysInCacheTableViews() {
    const nonFocusedTableQuery = getNonFocusedInboxTableQuery();
    const focusedTableQuery = getFocusedInboxTableQuery();
    const otherTableQuery = getOtherInboxTableQuery();

    if (isFocusedInboxEnabled()) {
        // Add focused other table and remove non-focused inbox
        addToAlwaysInCacheList(FOCUSED_INBOX, focusedTableQuery);
        addToAlwaysInCacheList(OTHER_INBOX, otherTableQuery);
        removeFromAlwaysInCacheList(ALL_INBOX, nonFocusedTableQuery);

        // VSO 13075: Read focused/other rollup data from session data response on boot
        // Making this additional request to get folder change digest for now
        if (!isInboxPlusEnabled()) {
            getFolderChangeDigestAction(otherTableQuery);
        }
    } else {
        // Remove focused other table and add non-focused inbox
        removeFromAlwaysInCacheList(FOCUSED_INBOX, focusedTableQuery);
        removeFromAlwaysInCacheList(OTHER_INBOX, otherTableQuery);
        addToAlwaysInCacheList(ALL_INBOX, nonFocusedTableQuery);
    }
}
